import script from "./SharedCardUndanitas.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedCardUndanitas.vue?vue&type=script&setup=true&lang=js"

import "./SharedCardUndanitas.vue?vue&type=style&index=0&id=e3f64618&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3f64618"]])

export default __exports__